// src/App.js
import React from 'react';
import { Routes, Route } from 'react-router-dom';
import Header from './components/Header';
import Footer from './components/Footer';
import Home from './pages/Home';
import InstructionPage from './pages/InstructionPage';
import PrivacyPolicy from './pages/PrivacyPolicy';
import { useScrollToHash } from './hooks/useScrollToHash';
import FAQ from './components/FAQ'; // ✅ Импортируем
import ContactForm from './components/ContactForm'; // ✅ Импортируем

function App() {
  useScrollToHash();

  return (
    <>
      <Header />
      <main>
        <Routes>
          <Route path="/" element={<Home />} />
          <Route path="/instruction" element={<InstructionPage />} />
          <Route path="/privacy-policy" element={<PrivacyPolicy />} />
        </Routes>
        <FAQ /> {/* ✅ Вставляем перед футером */}
        
      </main>
      <Footer />
    </>
  );
}

export default App;